const { DEPARTMENTS } = require("./company.types");

const PLANNING_LOCATION_TYPE = {
  CUSTOMER: {
    key: "CUSTOMER",
    label: {
      nl: "Klant",
      en: "Customer",
      fr: "Client",
    },
  },
  INHOUSE: {
    key: "INHOUSE",
    label: {
      nl: "In huis",
      en: "In house",
      fr: "Sur place",
    },
  },
  SUPPLIER: {
    key: "SUPPLIER",
    label: {
      nl: "Leverancier",
      en: "Supplier",
      fr: "Fournisseur",
    },
  },
  OTHER: {
    key: "OTHER",
    label: {
      nl: "Anders",
      en: "Other",
      fr: "Autre",
    },
  },
};

const PLANNING_STATUS = {
  NOTCONFIRMED: {
    key: "NOTCONFIRMED",
    label: {
      nl: "Niet bevestigd",
      en: "Not confirmed",
      fr: "Non confirmé",
    },
    color: "#FFC107",
  },
  CONFIRMED: {
    key: "CONFIRMED",
    label: {
      nl: "Afgesproken",
      en: "Confirmed",
      fr: "Confirmé",
    },
    color: "#28A745",
  },
  ONGOING: {
    key: "ONGOING",
    label: {
      nl: "In uitvoering",
      en: "In progress",
      fr: "En cours",
    },
    color: "#17A2B8",
  },
  COMPLETED: {
    key: "COMPLETED",
    label: {
      nl: "Voltooid",
      en: "Completed",
      fr: "Terminé",
    },
    color: "#28A745",
  },
  CANCELLED: {
    key: "CANCELLED",
    label: {
      nl: "Geannuleerd",
      en: "Cancelled",
      fr: "Annulé",
    },
    color: "#DC3545",
  },

  DELETED: {
    key: "DELETED",
    label: {
      nl: "Verwijderd",
      en: "Deleted",
      fr: "Supprimé",
    },
    color: "#DC3545",
  },
};

const PLANNING_TYPES = {
  GENERIC: {
    key: "GENERIC",
    label: {
      nl: "Algemeen",
      en: "Generic",
      fr: "Générique",
    },
  },
  SERVICE: {
    key: "SERVICE",
    label: {
      nl: "Service",
      en: "Service",
      fr: "Service réparateur",
    },
  },
  SALES: {
    key: "SALES",
    label: {
      nl: "Verkoop",
      en: "Sales",
      fr: "Vente",
    },
  },
};

const SERVICE_TASK_STATUS = {
  HRF: {
    0: {
      key: "NONE",
      number: 0,
      label: {
        nl: "Geen",
        en: "None",
        fr: "Aucun",
      },
      SUBSTATUS: {
        0: {
          key: "NONE",
          number: 0,
          label: {
            nl: "Geen",
            en: "None",
            fr: "Aucun",
          },
        },
      },
    },

    1: {
      key: "NOT_STARTED",
      number: 1,
      label: {
        nl: "Niet gestart",
        en: "Not started",
        fr: "Non commencé",
      },
      SUBSTATUS: {
        0: {
          key: "ALL",
          number: 0,
          label: {
            nl: "Alles",
            en: "All",
            fr: "Tous",
          },
        },
        1: {
          key: "LASER_AND_PLASMA_TOOL",
          number: 1,
          label: {
            nl: "Las- en Plasmatoestel",
            en: "Laser and Plasma tool",
            fr: "Laser et Plasma",
          },
        },
        2: {
          key: "MANUAL_AND_ELECTRIC_TOOL",
          number: 2,
          label: {
            nl: "Gereedschap man. en elektr.",
            en: "Manual and electric tool",
            fr: "Outil manuel et électrique",
          },
        },
        3: {
          key: "METAL_AND_WOOD_MACHINES",
          number: 3,
          label: {
            nl: "Bewerkingsmachines metaal hout",
            en: "Metal and wood machines",
            fr: "Machines métal et bois",
          },
        },
        4: {
          key: "TOORTSEN_MIG_TIG_PLASMA",
          number: 4,
          label: {
            nl: "Toortsen Mig Tig Plasma",
            en: "Toortsen Mig Tig Plasma",
            fr: "Toortsen Mig Tig Plasma",
          },
        },
        5: {
          key: "SLIJPDIENST",
          number: 5,
          label: {
            nl: "Slijpdienst",
            en: "Grinding service",
            fr: "Service d’affûtage",
          },
        },
        6: {
          key: "RETOUR_VERHUUR_EN_OP_PROEF",
          number: 6,
          label: {
            nl: "Retour verhuur en op proef",
            en: "Return rental and on trial",
            fr: "Retour location et sur essai",
          },
        },
        7: {
          key: "OPSTUR_LEVERANCIER",
          number: 7,
          label: {
            nl: "Opsturen leverancier",
            en: "Send to supplier",
            fr: "Envoyer au fournisseur",
          },
        },
        8: {
          key: "LASTAFELS_EN_TOEBEH",
          number: 8,
          label: {
            nl: "Lastafels en toebeh.",
            en: "Welding tables and accessories",
            fr: "Tables de soudage et accessoires",
          },
        },
      },
    },

    2: {
      key: "IN_PROGRESS_INTERNAL",
      number: 2,
      label: {
        nl: "In behandeling intern",
        en: "In progress internal",
        fr: "En cours interne",
      },
      SUBSTATUS: {
        0: {
          key: "ALL",
          number: 0,
          label: {
            nl: "Alles",
            en: "All",
            fr: "Tous",
          },
        },
        1: {
          key: "BESTEK_OPMAKEN",
          number: 1,
          label: {
            nl: "Bestek opmaken",
            en: "Prepare quotation",
            fr: "Établir l’offre",
          },
        },
        5: {
          key: "BESTEK_NAKIJKEN_TECHNIEKER",
          number: 5,
          label: {
            nl: "Bestek nakijken technieker",
            en: "Technician checks quotation",
            fr: "Vérification de l’offre par technicien",
          },
        },
        10: {
          key: "WACHTEN_KL_ONHERSTELBAAR_BESTEK",
          number: 10,
          label: {
            nl: "Wachten kl. Onherstelbaar bestek",
            en: "Waiting customer: irreparable quotation",
            fr: "En attente client: offre non réparable",
          },
        },
        15: {
          key: "WACHTEN_KL_HERSTELBAAR_BESTEK",
          number: 15,
          label: {
            nl: "Wachten kl. Herstelbaar bestek",
            en: "Waiting customer: repairable quotation",
            fr: "En attente client: offre réparable",
          },
        },
        20: {
          key: "KLANT_AKKOORD_HERSTELLING",
          number: 20,
          label: {
            nl: "Antwoord klant - mag hersteld worden",
            en: "Customer: repair approved",
            fr: "Client: réparation approuvée",
          },
        },
        25: {
          key: "KLANT_GEEN_HERSTELLING",
          number: 25,
          label: {
            nl: "Antwoord klant - niet herstellen",
            en: "Customer: do not repair",
            fr: "Client: ne pas réparer",
          },
        },
        30: {
          key: "STUKKEN_BESTELLEN_OF_PRIJSAANVRAAG",
          number: 30,
          label: {
            nl: "Stukken bestellen / Prijsaanvraag",
            en: "Order parts / Request prices",
            fr: "Commander pièces / Demande de prix",
          },
        },
        35: {
          key: "WACHTEN_OP_STUKKEN",
          number: 35,
          label: {
            nl: "Wachten op stukken",
            en: "Waiting for parts",
            fr: "En attente des pièces",
          },
        },
        40: {
          key: "STUKKEN_BINNEN_WACHT_OP_ACTIE_TEC",
          number: 40,
          label: {
            nl: "Stukken binnengekomen wacht op actie tec.",
            en: "Parts arrived, waiting technician action",
            fr: "Pièces arrivées, en attente action technicien",
          },
        },
        45: {
          key: "VERDER_OPVOLGING_NODIG",
          number: 45,
          label: {
            nl: "Verder opvolging nodig",
            en: "Further follow-up needed",
            fr: "Suivi supplémentaire nécessaire",
          },
        },
      },
    },

    4: {
      key: "IN_PROGRESS_SUPPLIER",
      number: 4,
      label: {
        nl: "In behandeling Leverancier",
        en: "In progress supplier",
        fr: "En cours fournisseur",
      },
      SUBSTATUS: {
        0: {
          key: "ALL",
          number: 0,
          label: {
            nl: "Alles",
            en: "All",
            fr: "Tous",
          },
        },
        5: {
          key: "KLAAR_VOOR_VERZENDING",
          number: 5,
          label: {
            nl: "Klaar voor verzending",
            en: "Ready for shipment",
            fr: "Prêt pour l’expédition",
          },
        },
        10: {
          key: "VERZONDEN",
          number: 10,
          label: {
            nl: "Verzonden",
            en: "Shipped",
            fr: "Expédié",
          },
        },
        15: {
          key: "WACHTEN_KL_ONHERSTELBAAR_BESTEK_SUPPLIER",
          number: 15,
          label: {
            nl: "Wachten kl. Onherstelbaar bestek",
            en: "Waiting customer: irreparable quotation",
            fr: "En attente client: offre non réparable",
          },
        },
        20: {
          key: "WACHTEN_KL_HERSTELBAAR_BESTEK_SUPPLIER",
          number: 20,
          label: {
            nl: "Wachten kl. Herstelbaar bestek",
            en: "Waiting customer: repairable quotation",
            fr: "En attente client: offre réparable",
          },
        },
        25: {
          key: "KLANT_AKKOORD_HERSTELLING_SUPPLIER",
          number: 25,
          label: {
            nl: "Antwoord kl. mag hersteld worden",
            en: "Customer: repair approved (supplier)",
            fr: "Client: réparation approuvée (fournisseur)",
          },
        },
        30: {
          key: "KLANT_GEEN_HERSTELLING_SUPPLIER",
          number: 30,
          label: {
            nl: "Antwoord kl. niet herstellen",
            en: "Customer: do not repair (supplier)",
            fr: "Client: ne pas réparer (fournisseur)",
          },
        },
        35: {
          key: "VERDERE_OPVOLGING_NODIG_SUPPLIER",
          number: 35,
          label: {
            nl: "Verdere opvolging nodig",
            en: "Further follow-up needed",
            fr: "Suivi supplémentaire nécessaire",
          },
        },
      },
    },

    10: {
      key: "REPAIRED_OR_NOT_REPAIRED",
      number: 10,
      label: {
        nl: "Hersteld/Niet hersteld",
        en: "Repaired / Not repaired",
        fr: "Réparé / Non réparé",
      },
      SUBSTATUS: {
        0: {
          key: "ALL",
          number: 0,
          label: {
            nl: "Alles",
            en: "All",
            fr: "Tous",
          },
        },
        1: {
          key: "HERSTELD",
          number: 1,
          label: {
            nl: "Hersteld",
            en: "Repaired",
            fr: "Réparé",
          },
        },
        2: {
          key: "ONHERSTELD_TERUG",
          number: 2,
          label: {
            nl: "Onhersteld terug",
            en: "Returned unrepaired",
            fr: "Retourné non réparé",
          },
        },
        3: {
          key: "NIET_HERSTELD",
          number: 3,
          label: {
            nl: "Niet hersteld",
            en: "Not repaired",
            fr: "Non réparé",
          },
        },
        4: {
          key: "TE_VERWITTIGEN",
          number: 4,
          label: {
            nl: "Te verwittigen",
            en: "To be notified",
            fr: "À avertir",
          },
        },
        5: {
          key: "VERWITTIGD",
          number: 5,
          label: {
            nl: "Verwittigd",
            en: "Notified",
            fr: "Averti",
          },
        },
        6: {
          key: "TE_VERNIETIGEN",
          number: 6,
          label: {
            nl: "Te Vernietigen",
            en: "To be scrapped",
            fr: "À détruire",
          },
        },
        7: {
          key: "RECUP",
          number: 7,
          label: {
            nl: "Recup",
            en: "Salvage",
            fr: "Récupération",
          },
        },
        8: {
          key: "VERNIETIGD_OF_RECUPED",
          number: 8,
          label: {
            nl: "Vernietigd/Recuped",
            en: "Scrapped/Salvaged",
            fr: "Détruit/Récupéré",
          },
        },
      },
    },

    15: {
      key: "DELIVERED",
      number: 15,
      label: {
        nl: "Geleverd",
        en: "Delivered",
        fr: "Livré",
      },
      SUBSTATUS: {
        0: {
          key: "ALL",
          number: 0,
          label: {
            nl: "Alles",
            en: "All",
            fr: "Tous",
          },
        },
        1: {
          key: "GELEVERD",
          number: 1,
          label: {
            nl: "Geleverd",
            en: "Delivered",
            fr: "Livré",
          },
        },
      },
    },

    20: {
      key: "INVOICED",
      number: 20,
      label: {
        nl: "Uitgerekend",
        en: "Invoiced / Calculated",
        fr: "Facturé / Calculé",
      },
      SUBSTATUS: {
        0: {
          key: "ALL",
          number: 0,
          label: {
            nl: "Alles",
            en: "All",
            fr: "Tous",
          },
        },
        3: {
          key: "UITGEREKEND",
          number: 3,
          label: {
            nl: "Uitgerekend",
            en: "Invoiced / Calculated",
            fr: "Facturé / Calculé",
          },
        },
      },
    },
  },

  MOF: {
    1: {
      key: "NOT_STARTED",
      number: 1,
      label: {
        nl: "Niet gestart",
        en: "Not started",
        fr: "Non commencé",
      },
      SUBSTATUS: {
        5: {
          key: "NEW",
          number: 5,
          label: {
            nl: "Nieuw",
            en: "New",
            fr: "Nouveau",
          },
        },
        10: {
          key: "WAITING_FOR_DELIVERY",
          number: 10,
          label: {
            nl: "Wachten aanlevering",
            en: "Waiting for delivery",
            fr: "En attente de livraison",
          },
        },
      },
    },
    10: {
      key: "INSTALLATION_INTERNAL",
      number: 10,
      label: {
        nl: "Montage Intern",
        en: "Installation Internal",
        fr: "Installation interne",
      },
      SUBSTATUS: {
        1: {
          key: "TECHNICIAN_ACTION",
          number: 1,
          label: {
            nl: "Actie Technieker",
            en: "Technician action",
            fr: "Action technicien",
          },
        },
        2: {
          key: "ORDER_START_UP_MATERIAL",
          number: 3,
          label: {
            nl: "Opstartmateriaal bestellen",
            en: "Order start-up material",
            fr: "Commander matériel de démarrage",
          },
        },
        3: {
          key: "START_UP_MATERIAL_ARRIVED",
          number: 3,
          label: {
            nl: "Opstartmateriaal binnengekomen",
            en: "Start-up material arrived",
            fr: "Matériel de démarrage arrivé",
          },
        },
        4: {
          key: "PARTIALLY_DONE",
          number: 4,
          label: {
            nl: "Deels gedaan",
            en: "Partially done",
            fr: "Partiellement fait",
          },
        },
      },
    },
    15: {
      key: "START_UP_INTERNAL",
      number: 15,
      label: {
        nl: "Opstart Intern",
        en: "Start-up Internal",
        fr: "Installation interne",
      },
      SUBSTATUS: {
        1: {
          key: "AGREE_WITH_CUSTOMER",
          number: 1,
          label: {
            nl: "Afspreken met klant",
            en: "Agree with customer",
            fr: "Agir avec le client",
          },
        },
        2: {
          key: "AGREED",
          number: 2,
          label: {
            nl: "Afgesproken",
            en: "Agreed",
            fr: "Agir",
          },
        },
      },
    },
    20: {
      key: "START_UP_EXTERNAL",
      number: 20,
      label: {
        nl: "Transport  ",
        en: "Transport",
        fr: "Transport",
      },
      SUBSTATUS: {
        1: {
          key: "ARRANGE_TRANSPORT",
          number: 1,
          label: {
            nl: "Transport Regelen",
            en: "Transport arrange",
            fr: "Transport organiser",
          },
        },
        2: {
          key: "CALL_CUSTOMER",
          number: 2,
          label: {
            nl: "Afroep klant",
            en: "Call customer",
            fr: "Appeler le client",
          },
        },
      },
    },
    25: {
      key: "MONTAGE_EXTERNAL",
      number: 25,
      label: {
        nl: "Montage Extern",
        en: "Montage External",
        fr: "Montage externe",
      },
      SUBSTATUS: {
        1: {
          key: "ORDER_PARTS",
          number: 1,
          label: {
            nl: "Onderdelen bestellen",
            en: "Order parts",
            fr: "Commander pièces",
          },
        },
        2: {
          key: "PARTS_ARRIVED",
          number: 2,
          label: {
            nl: "Onderdelen binnengekomen",
            en: "Parts arrived",
            fr: "Pièces arrivées",
          },
        },
        3: {
          key: "AGREE_WITH_CUSTOMER",
          number: 3,
          label: {
            nl: "Afspreken met klant",
            en: "Agree with customer",
            fr: "Agir avec le client",
          },
        },
        4: {
          key: "AGREED",
          number: 4,
          label: {
            nl: "Afgesproken",
            en: "Agreed",
            fr: "Agir",
          },
        },
      },
    },
    30: {
      key: "START_UP_EXTERNAL",
      number: 30,
      label: {
        nl: "Opstart Extern",
        en: "Start-up External",
        fr: "Installation externe",
      },

      SUBSTATUS: {
        1: {
          key: "AGREE_WITH_CUSTOMER",
          number: 1,
          label: {
            nl: "Afspreken met klant",
            en: "Agree with customer",
            fr: "Agir avec le client",
          },
        },
        2: {
          key: "AGREED",
          number: 2,
          label: {
            nl: "Afgesproken",
            en: "Agreed",
            fr: "Agir",
          },
        },
        3: {
          key: "CALL_CUSTOMER",
          number: 3,
          label: {
            nl: "Afroep klant",
            en: "Call customer",
            fr: "Appeler le client",
          },
        },
      },
    },
    35: {
      key: "START_UP_RENTAL",
      number: 35,
      label: {
        nl: "Opstart/verhuur",
        en: "Start-up/rental",
        fr: "Installation/location",
      },
      SUBSTATUS: {
        1: {
          key: "STARTED",
          number: 1,
          label: {
            nl: "Opgestart",
            en: "Started",
            fr: "Démarré",
          },
        },
        2: {
          key: "RENTAL_CHECKED",
          number: 2,
          label: {
            nl: "Verhuur nagekeken",
            en: "Rental checked",
            fr: "Location vérifiée",
          },
        },
        3: {
          key: "DELIVERED",
          number: 3,
          label: {
            nl: "Uitgeleverd",
            en: "Delivered",
            fr: "Livré",
          },
        },
        4: {
          key: "HANDLED",
          number: 4,
          label: {
            nl: "Afgehandeld",
            en: "Handled",
            fr: "Géré",
          },
        },
      },
    },
  },

  TODO: {
    1: {
      key: "OPEN",
      number: 1,
      label: {
        nl: "Open",
        en: "Open",
        fr: "Ouvert",
      },
      SUBSTATUS: {
        0: {
          key: "NONE",
          number: 0,
          label: {
            nl: "Geen",
            en: "None",
            fr: "Aucun",
          },
        },
      },
    },
    2: {
      key: "IN_PROGRESS",
      number: 2,
      label: {
        nl: "In uitvoering",
        en: "In progress",
        fr: "En cours",
      },
      SUBSTATUS: {
        0: {
          key: "NONE",
          number: 0,
          label: {
            nl: "Geen",
            en: "None",
            fr: "Aucun",
          },
        },
      },
    },
    3: {
      key: "DONE",
      number: 3,
      label: {
        nl: "Voltooid",
        en: "Done",
        fr: "Terminé",
      },
      SUBSTATUS: {
        0: {
          key: "NONE",
          number: 0,
          label: {
            nl: "Geen",
            en: "None",
            fr: "Aucun",
          },
        },
      },
    },
  },
};

const TODO_STATUS = {
  OPEN: {
    key: "OPEN",
    number: 1,
    label: {
      nl: "Open",
      en: "Open",
      fr: "Ouvert",
    },
    color: "#17A2B8",
  },
  IN_PROGRESS: {
    key: "IN_PROGRESS",
    number: 2,
    label: {
      nl: "In uitvoering",
      en: "In progress",
      fr: "En cours",
    },
    color: "#FFC107",
  },
  DONE: {
    key: "DONE",
    number: 3,
    label: {
      nl: "Voltooid",
      en: "Done",
      fr: "Terminé",
    },
    color: "#28A745",
  },
  CANCELLED: {
    key: "CANCELLED",
    number: 4,
    label: {
      nl: "Geannuleerd",
      en: "Cancelled",
      fr: "Annulé",
    },
    color: "#DC3545",
  },
};

const TODO_RECURRENCE_FREQUENCY = {
  NONE: {
    key: "NONE",
    label: {
      nl: "Eenmalig",
      en: "One-time",
      fr: "Unique",
    },
  },
  DAILY: {
    key: "DAILY",
    label: {
      nl: "Dagelijks",
      en: "Daily",
      fr: "Quotidien",
    },
  },
  WEEKLY: {
    key: "WEEKLY",
    label: {
      nl: "Wekelijks",
      en: "Weekly",
      fr: "Hebdomadaire",
    },
  },
  MONTHLY: {
    key: "MONTHLY",
    label: {
      nl: "Maandelijks",
      en: "Monthly",
      fr: "Mensuel",
    },
  },
};

const PLANNING_SUBTYPES = {
  [PLANNING_TYPES.GENERIC.key]: {
    GENERIC: {
      key: "GENERIC",
      label: {
        nl: "Algemeen",
        en: "Generic",
        fr: "Générique",
      },
    },
  },
  [PLANNING_TYPES.SERVICE.key]: {
    MOF: {
      ME: {
        key: "ME",
        checkField: "MONTAGEEXT",
        label: {
          nl: "Montage Extern",
          en: "Installation External",
          fr: "Montage Externe",
        },
      },
      MI: {
        key: "MI",
        checkField: "MONTAGEINT",
        label: {
          nl: "Montage Intern",
          en: "Installation Internal",
          fr: "Montage Interne",
        },
      },
      OE: {
        key: "OE",
        checkField: "OPSTARTEXT",
        label: {
          nl: "Opstart Extern",
          en: "Start-up External",
          fr: "Installation Externe",
        },
      },
      OI: {
        key: "OI",
        checkField: "OPSTARTINT",
        label: {
          nl: "Opstart Intern",
          en: "Start-up Internal",
          fr: "Installation Interne",
        },
      },
    },
    HRF: {
      REPAIR: {
        key: "REPAIR",
        label: {
          nl: "Herstelling",
          en: "Repair",
          fr: "Réparation",
        },
      },
      MOF: {
        key: "MOF",
        label: {
          nl: "Montage/Opstart",
          en: "Installation/Start-up",
          fr: "Installation/Démarrage",
        },
      },
      DEMO: {
        key: "DEMO",
        label: {
          nl: "Demo",
          en: "Demo",
          fr: "Démonstration",
        },
      },
      RENTAL: {
        key: "RENTAL",
        label: {
          nl: "Verhuur",
          en: "Rental",
          fr: "Location",
        },
      },
      MAINTENANCE: {
        key: "MAINTENANCE",
        label: {
          nl: "Onderhoud",
          en: "Maintenance",
          fr: "Maintenance",
        },
      },
      TRAINING: {
        key: "TRAINING",
        label: {
          nl: "Opleiding",
          en: "Training",
          fr: "Formation",
        },
      },
      WARRANTY: {
        key: "WARRANTY",
        label: {
          nl: "Garantie",
          en: "Warranty",
          fr: "Warranty",
        },
      },
      MAINTENAANCE_CONTRACT: {
        key: "MAINTENAANCE_CONTRACT",
        label: {
          nl: "Onderhoudscontract",
          en: "Maintenance contract",
          fr: "Contrat de maintenance",
        },
      },
      ALL_IN_CONTRACT: {
        key: "ALL_IN_CONTRACT",
        label: {
          nl: "All-in contract",
          en: "All-in contract",
          fr: "Contrat tout-en-un",
        },
      },
      TRAINING_EXTERNAL: {
        key: "TRAINING_EXTERNAL",
        label: {
          nl: "Externe opleiding",
          en: "External training",
          fr: "Formation externe",
        },
      },
    },
    TODO: {
      TODO: {
        key: "TODO",
        label: {
          nl: "Todo",
          en: "Todo",
          fr: "Todo",
        },
      },
    },
  },
  [PLANNING_TYPES.SALES.key]: {
    GENERIC: {
      key: "GENERIC",
      label: {
        nl: "Algemeen",
        en: "Generic",
        fr: "Générique",
      },
    },
    VISIT: {
      key: "VISIT",
      label: {
        nl: "Bezoek",
        en: "Visit",
        fr: "Visite",
      },
    },
    MEETING: {
      key: "MEETING",
      label: {
        nl: "Meeting",
        en: "Meeting",
        fr: "Meeting",
      },
    },
  },
};

// external entities that can be linked to a planning.
const PLANNABLE_DOC_TYPE = {
  HRB: "HRB", // service
  VKO: "VKO", // service
  VHO: "VHO", // service
  DPO: "DPO", // service
  CONTACT: "CONTACT", // sales
  PROJECT: "PRJ", // sales
  OTHER: "OTHER", // not linked
  TODO: "TODO", // intranet todos
};

const PLANNABLE_FICHE_TYPE = {
  MOF: "MOF",
  HRF: "HRF",
  TODO: "TODO",
};

const PLANNABLE_DOC_SOURCE = {
  DIAS: "DIAS",
  FINERP: "FINERP",
  MONGODB: "MONGODB",
};

const PLANNABLE_DOC_ID_LABEL = {
  DIAS: {
    HRB: "FICHE",
    VKO: "VKORD",
    VHO: "DOKNR",
    DPO: "DOKNR",
    MOF: "SERFICHE",
  },
  FINERP: {
    HRB: "DOKNR",
  },
  MONGODB: {
    HRB: "DOKNR",
    VKO: "DOKNR",
    VHO: "DOKNR",
    DPO: "DOKNR",
    MOF: "SERFICHE",
    TODO: "todoNumber",
  },
};

const FIELDS_FROM_FICHE = {
  MOF: {
    keyFields: {
      sourceFicheId: "SERFICHE",
    },
    obj: "service",
    mapping: {
      //locationType: "SERBIJKLANT",
      reason: "SERTEKST",
      status: "SERSTATUSNR",
      subStatus: "SERSUBSTATUSNR",
      machineName: "SERTEKST",
      machineType: "", //TODO: add machine type
      machineSerialNumber: "", //TODO: add machine serial number
      machineCounter: "", //TODO: add machine counter
      isExternalTask: "SERBIJKLANT",
      MONTAGEINT: "MONTAGEINT",
      MONTAGEEXT: "MONTAGEEXT",
      OPSTARTINT: "OPSTARTINT",
      OPSTARTEXT: "OPSTARTEXT",
      sourceFicheId: "SERFICHE",
    },
  },
};

const FIELDS_FROM_PARENT_DOC = {
  MOF: {
    keyFields: {
      sourceDocId: "DOKNR",
      dossierNr: "DOSSIERNR",
    },
    mapping: {
      customerNumber: "KLANTNR",
      customerName: "KLANAAM",
      customerStreet: "ADLIJN1",
      customerZip: "ADPOSTC",
      customerCity: "ADLOC",
      customerLevStreet: "ADLEVLIJN1",
      customerLevZip: "ADLEVPOSTC",
      customerLevCity: "ADLEVLOC",
      // contactName: "CONTACTNAAM",
      // contactEmail: "CONTACTEMAIL",
      // contactPhone: "CONTACTPHONE",
      docNr: "DOKNR",
      docType: "DOKTYPE",
      docDate: "DAT",
      ADLEVLAT: "ADLEVLAT",
      ADLEVLON: "ADLEVLON",
      ADLAT: "ADLAT",
      ADLON: "ADLON",
    },
  },
  HRF: {
    keyFields: {
      sourceDocId: "DOKNR",
      dossierNr: "DOSSIERNR",
    },
    mapping: {
      customerNumber: "KLANTNR",
      customerName: "KLANAAM",
      customerStreet: "ADLIJN1",
      customerZip: "ADPOSTC",
      customerCity: "ADLOC",
      customerLevStreet: "ADLEVLIJN1",
      customerLevZip: "ADLEVPOSTC",
      customerLevCity: "ADLEVLOC",
      // contactName: "CONTACTNAAM",
      // contactEmail: "CONTACTEMAIL",
      // contactPhone: "CONTACTPHONE",
      // locationType: "HERSTELKL",
      isExternalTask: "HERSTELKL",
      reason: "HERSTREDEN",
      status: "HERSTATUSNR",
      subStatus: "HERSUBSTATUSNR",
      docType: "DOKTYPE",
      docDate: "DAT",
      machineName: "TEKST",
      machineType: "", //TODO: add machine type
      machineSerialNumber: "", //TODO: add machine serial number
      machineCounter: "", //TODO: add machine counter
      ADLEVLAT: "ADLEVLAT",
      ADLEVLON: "ADLEVLON",
      ADLAT: "ADLAT",
      ADLON: "ADLON",
      sourceDocId: "DOKNR",
      GARANTIE: "GARANTIE",
      BESTEK: "BESTEK"
    },
  },
};

const PLANNABLE_TYPES = PLANNING_TYPES;

module.exports = {
  PLANNING_LOCATION_TYPE,
  PLANNING_STATUS,
  DEPARTMENTS,
  PLANNING_TYPES,
  PLANNABLE_TYPES,
  PLANNING_SUBTYPES,
  PLANNABLE_DOC_TYPE,
  PLANNABLE_FICHE_TYPE,
  PLANNABLE_DOC_SOURCE,
  PLANNABLE_DOC_ID_LABEL,

  SERVICE_TASK_STATUS,
  TODO_STATUS,
  TODO_RECURRENCE_FREQUENCY,
  FIELDS_FROM_PARENT_DOC,
  FIELDS_FROM_FICHE,
};
